import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { useStudentsDisabled } from '@/contexts/ConfigContext';

export const Route = createFileRoute('/$tenantId/_layout/students')({
  component: StudentsLayout,
});

function StudentsLayout() {
  const { tenantId } = Route.useParams();
  const studentsDisabled = useStudentsDisabled();

  if (studentsDisabled) {
    return <Navigate to="/$tenantId" params={{ tenantId }} replace />;
  }

  return <Outlet />;
}
